import reducers from "./loginReducers";

export default reducers;